/**
 *
 * Asynchronously loads the component for Footer
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
